(() => {
  const SETTINGS_ID = 'FNF-CartOfferSettings';
  const OFFER_CLASS = 'fnf-cart-offer';
  let refreshTimer = null;

  const escapeHTML = (value = '') =>
    String(value).replace(/[&<>"']/g, (character) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return entities[character];
    });

  const getSettings = () => {
    const node = document.getElementById(SETTINGS_ID);
    if (!node) return null;

    return {
      enabled: node.dataset.enabled === 'true',
      code: node.dataset.code || 'RAKHIWITHFNF',
      threshold: Number(node.dataset.threshold || 249900),
      discount: node.dataset.discount || 'additional 5% off',
      showProgress: node.dataset.showProgress === 'true',
      currency: node.dataset.currency || 'INR'
    };
  };

  const formatMoney = (cents, currency = 'INR') => {
    const amount = Math.max(0, Number(cents || 0)) / 100;

    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency,
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return `Rs. ${amount.toFixed(2)}`;
    }
  };

  const renderOffer = (cart) => {
    const settings = getSettings();
    const subtotal = document.querySelector(
      '#MinimogCartDrawerFooter .m-cart__subtotal[data-cart-subtotal], #MinimogCartDrawerFooter .m-cart__subtotal'
    );

    if (!subtotal || !settings) return;

    const currentOffer =
      subtotal.parentElement?.querySelector(`.${OFFER_CLASS}`) ||
      document.querySelector(`#MinimogCartDrawerFooter .${OFFER_CLASS}`);

    if (!settings.enabled || !cart || Number(cart.item_count || 0) === 0) {
      currentOffer?.remove();
      return;
    }

    const total = Number(cart.total_price || 0);
    const threshold = Math.max(0, Number(settings.threshold || 0));
    const remaining = Math.max(threshold - total, 0);
    const unlocked = threshold === 0 || total >= threshold;
    const progress = threshold > 0 ? Math.min((total / threshold) * 100, 100) : 100;

    let offer = currentOffer;
    if (!offer) {
      offer = document.createElement('div');
      offer.className = OFFER_CLASS;
      subtotal.before(offer);
    }

    offer.classList.toggle('fnf-cart-offer--unlocked', unlocked);

    const code = escapeHTML(settings.code);
    const discount = escapeHTML(settings.discount);
    const thresholdMoney = escapeHTML(formatMoney(threshold, settings.currency));
    const remainingMoney = escapeHTML(formatMoney(remaining, settings.currency));

    const progressMarkup = settings.showProgress
      ? `
        <div class="fnf-cart-offer__progress" role="progressbar" aria-label="Offer progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}">
          <span class="fnf-cart-offer__progress-bar" style="width:${progress.toFixed(2)}%"></span>
        </div>
      `
      : '';

    if (unlocked) {
      offer.innerHTML = `
        <p class="fnf-cart-offer__message">
          🎉 You've unlocked <strong>${discount}</strong>. Use coupon code
          <strong class="fnf-cart-offer__code">${code}</strong> at checkout.
        </p>
        ${progressMarkup}
      `;
      return;
    }

    offer.innerHTML = `
      <p class="fnf-cart-offer__message">
        Use coupon code <strong class="fnf-cart-offer__code">${code}</strong>
        to get <strong>${discount}</strong> on orders above <strong>${thresholdMoney}</strong>.
      </p>
      <p class="fnf-cart-offer__remaining">
        Add <strong>${remainingMoney}</strong> more to unlock the offer.
      </p>
      ${progressMarkup}
    `;
  };

  const fetchAndRender = async () => {
    const settings = getSettings();
    if (!settings) return;

    try {
      const root =
        window.Shopify?.routes?.root && typeof window.Shopify.routes.root === 'string'
          ? window.Shopify.routes.root
          : '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      renderOffer(cart);
    } catch (error) {
      // Keep native cart behavior untouched if the enhancement request fails.
    }
  };

  const queueRefresh = (delay = 120) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(fetchAndRender, delay);
  };

  document.addEventListener('cart:updated', (event) => {
    if (event.detail?.cart) {
      renderOffer(event.detail.cart);
    } else {
      queueRefresh();
    }
  });

  document.addEventListener('cart:refresh', () => queueRefresh(450));

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.(`#${SETTINGS_ID}`)) queueRefresh(0);
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event.target?.querySelector?.(`#${SETTINGS_ID}`)) queueRefresh(0);
  });

  document.addEventListener('DOMContentLoaded', () => queueRefresh(0));

  if (document.readyState !== 'loading') {
    queueRefresh(0);
  }
})();
